import React from "react";
import { Plus } from "@phosphor-icons/react";
import EventCard from "./EventCard";

export default function EventsTab({ events, onAdd, onEdit, onDelete }) {
  return (
    <div className="bg-white border border-slate-200 rounded-lg">
      <div className="px-6 py-4 border-b border-slate-200 flex items-center justify-between">
        <div>
          <h3 className="font-heading font-semibold text-slate-900">
            Engagement Events
          </h3>
          <p className="text-xs text-slate-500 mt-0.5">
            Meetings, calls and touch-points with this customer
          </p>
        </div>
        <button
          onClick={onAdd}
          data-testid="add-event-button"
          className="inline-flex items-center gap-2 px-3 h-9 rounded-md bg-blue-600 text-white text-sm font-medium hover:bg-blue-700"
        >
          <Plus size={16} weight="bold" /> Log Event
        </button>
      </div>
      {events.length === 0 ? (
        <div className="px-6 py-12 text-center text-sm text-slate-500">
          No events yet. Log your first meeting or call.
        </div>
      ) : (
        <div className="p-4 space-y-3">
          {events.map((ev) => (
            <EventCard
              key={ev.id}
              event={ev}
              onEdit={onEdit}
              onDelete={onDelete}
            />
          ))}
        </div>
      )}
    </div>
  );
}
